Action = require 'app/scripts/models/action'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Promise = require 'bluebird'
_ = require 'underscore'
ApiError = require 'app/scripts/network/api-error'

class ActionList extends CollectionWithHelpers
  model: Action

  initialize: (list, @options) ->

  comparator: (action) ->
    -action.getDate() || 0

  _getRelatedBoards: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    idBoardsRelated =
      for model in @models when model.get('type') in ['moveCardToBoard', 'moveCardFromBoard']
        data = model.get('data')
        data.boardTarget?.id || data.boardSource?.id

    idBoardsRelated = _.compact(_.uniq(idBoardsRelated))
    idBoardsRelated = _.reject(idBoardsRelated, (idBoard) => @modelCache.get('Board', idBoard)?)

    Promise.resolve(idBoardsRelated)
    .map (idBoard) =>
      ModelLoader.loadBoardName idBoard
      .catch ApiError.Unauthorized, ApiError.NotFound, (->)

module.exports = ActionList
